import {
  Box,
  Button,
  Checkbox,
  Divider,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid2,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import Warning from "Components/Common/Warning";
import React, { useState } from "react";
import { ReactComponent as MailIcon } from "Assets/Icons/Settings/MailIcon.svg";
import { ReactComponent as EditUserIcon } from "Assets/Icons/Classroom/EditUserIcon.svg";
import { ReactComponent as CalendarIcon } from "Assets/Icons/Home/CalendarIcon.svg";
import PrimaryIcon from "Components/Common/PrimaryIcon";
import PhoneNumberInput from "Components/Common/PhoneNumberInput";
import RedirectingDialog from "Components/Contest/RedirectingDialog";

const styles = (theme) => ({
  display: "flex",
  flexDirection: "column",
  gap: "15px",
  border: `1px solid ${theme.palette.border.blue}`,
  borderRadius: "8px",
  padding: "16px",
});

const StartInstructions = () => {
  const [redirectToContest, setRedirectToContest] = useState(false);
  return (
    <>
      <Grid2 sx={styles}>
        <Typography textAlign={"center"} variant="title" fontWeight={500}>
          DAV - Python Libraries
        </Typography>
        <Typography
          textAlign={"center"}
          variant="subtitle"
          fontWeight={500}
          color="secondary.light"
        >
          Instructions from Coded
        </Typography>
        <Typography
          sx={{
            "& ol": {
              paddingInlineStart: "20px",
              display: "flex",
              flexDirection: "column",
              gap: "10px",
            },
          }}
          color="secondary.light"
        >
          <ol>
            <li>This is a programming test.</li>
            <li>
              The code area contains the function signature. Just complete the
              function alone. We will take care of the main function, headers,
              etc
            </li>
            <li>
              Use 'Test' to run your solution against the sample test cases
              before submitting it.
            </li>
            <li>
              Use 'Test with custom input' to run your solution against your
              custom test cases.
            </li>
            <li>
              We run a proprietary plagiarism check on each submission. Please
              refrain from submitting code that is not written by you.
            </li>
          </ol>
        </Typography>
        <Box
          display={"flex"}
          flexDirection={"column"}
          gap="8px"
          sx={(theme) => ({
            border: `1px solid ${theme.palette.border.blue}`,
            borderRadius: "8px",
            padding: "16px",
          })}
        >
          <Typography color="secondary.light">
            This test will be active from 27 Sep 2023 6:30 PM +03 to 31 Dec 2025
            9:29 PM +03. You will have 60 minutes if you start before 31 Dec
            2025 8:29 PM +03.
          </Typography>
          <Typography color="secondary.light">
            You are free to choose any language from
          </Typography>
          <Typography letterSpacing={1}>
             Python (python-2.7) , C (gcc-4.8) , C# (.NET 8) , Bash (bash
            4.0.35) , PHP (php 5.5.9) , JavaScript (ES6) , Scala (scala-2.11.4)
            , MySQL (MySQL 5.6) , Swift (5.5) , Objective-C (clang 3.3) , C++17
            (gcc-9.2) , Java7 (open-jdk-1.7.0) , Text (text 6.10) , MySQL (MySQL
            8.0) , GO (1.17.4) , Python 3 (python-3.8) , R (R-3.5.1) , Java 8
            (array support) , Java 8 (oracle-jdk-1.8) , Ruby 2 (ruby-2.0)
            , Kotlin (openjdk8) , Elixir (Erlang/OTP 24) , Jest.
          </Typography>
        </Box>
        <Warning showAlert={false}>
          <Box>
            <Typography>
              Please refrain from performing the following restricted events:
            </Typography>
            <Typography color="secondary.light" letterSpacing={1}>
              Text Selection, Copy & Paste, Right Click, Opening Inspector,
              Debugging Console, Browser Settings, Closing the Session Tab
            </Typography>
          </Box>
        </Warning>
        <Typography color="secondary.light">
          Note:- These instructions will be available to you throughout the
          session.
        </Typography>
        <Box
          sx={(theme) => ({
            padding: "16px",
            border: `1px solid ${theme.palette.border.grey}`,
            borderRadius: "8px",
            background: theme.palette.background.default,
          })}
        >
          <Typography variant="subtitle" fontWeight={500}>
            Please provide following details
          </Typography>
          <Grid2 mt={"24px"} container spacing={2}>
            <Grid2 size={3}>
              <FormControl fullWidth>
                <FormLabel label>Enter Your Email</FormLabel>
                <TextField
                  size="small"
                  placeholder="What's your email?"
                  filled={"white"}
                  variant="outlined"
                  fullWidth
                  noBorder
                  slotProps={{
                    input: {
                      startAdornment: (
                        <InputAdornment position="start">
                          {" "}
                          <PrimaryIcon
                            icon={MailIcon}
                            color="secondary"
                            variant="light"
                            height="16px"
                          />{" "}
                          <Divider
                            sx={{ marginLeft: "10px" }}
                            flexItem
                            orientation="vertical"
                          />
                        </InputAdornment>
                      ),
                    },
                  }}
                />
              </FormControl>
            </Grid2>
            <Grid2 size={3}>
              <FormControl fullWidth>
                <FormLabel label>Enter Your Name</FormLabel>
                <TextField
                  size="small"
                  placeholder="Who are you?"
                  filled={"white"}
                  variant="outlined"
                  fullWidth
                  noBorder
                  slotProps={{
                    input: {
                      startAdornment: (
                        <InputAdornment position="start">
                          {" "}
                          <PrimaryIcon
                            icon={EditUserIcon}
                            color="secondary"
                            variant="light"
                            height="16px"
                          />{" "}
                          <Divider
                            sx={{ marginLeft: "10px" }}
                            flexItem
                            orientation="vertical"
                          />
                        </InputAdornment>
                      ),
                    },
                  }}
                />
              </FormControl>
            </Grid2>{" "}
            <Grid2 size={3}>
              <FormControl fullWidth>
                <FormLabel label>Enter Your Graduation Year</FormLabel>
                <TextField
                  size="small"
                  placeholder="When did/will you graduate?"
                  filled={"white"}
                  variant="outlined"
                  fullWidth
                  noBorder
                  slotProps={{
                    input: {
                      startAdornment: (
                        <InputAdornment position="start">
                          {" "}
                          <PrimaryIcon
                            icon={CalendarIcon}
                            color="secondary"
                            variant="light"
                            height="16px"
                          />{" "}
                          <Divider
                            sx={{ marginLeft: "10px" }}
                            flexItem
                            orientation="vertical"
                          />
                        </InputAdornment>
                      ),
                    },
                  }}
                />
              </FormControl>
            </Grid2>{" "}
            <Grid2 size={3}>
              <PhoneNumberInput
                textfieldProps={{ filled: "white", noBorder: true }}
              />
            </Grid2>
          </Grid2>
        </Box>
        <Box>
          <Typography display={"flex"} fontWeight={500} variant="subtitle">
            Disclaimer:
          </Typography>
          <FormControlLabel
            control={<Checkbox size="small" />}
            label="I agree not to copy code from any source (including websites, books, or friends and colleagues) to complete this assessment."
          />
          <FormControlLabel
            control={<Checkbox size="small" />}
            label="I acknowledge that I have read about the RESTRICTIONS and would wish to continue. Click here to read instructions."
          />
        </Box>
        <Button
          sx={(theme) => ({
            width: "fit-content",
            margin: "auto",
          })}
          variant="outlined"
          color="secondary"
          onClick={() => setRedirectToContest(true)}
        >
          Start Test
        </Button>
      </Grid2>
      <RedirectingDialog
        open={redirectToContest}
        setOpen={setRedirectToContest}
      />
    </>
  );
};

export default StartInstructions;
